import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Shopkeeper from "../../Services/shopkeeperServices";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import TitleHeader from "../accounts/Components/TitleHeader";
import { AuthContext } from "../../Auth/Context/AuthContext";
function ShopkeeperFullDetails(props) {
  const { shopkeeperId, branchId } = useParams();
  const { user } = useContext(AuthContext);
  const [shop, setShop] = useState();
  const [shopkeeperShops, setShopkeeperShops] = useState();
  const [rents, setRents] = useState();
  const [loading, setLoading] = useState(false);

  const toast = useRef(null);
  const getShopkeeper = async () => {
    setLoading(true);
    await Shopkeeper.getOne(shopkeeperId)
      .then((data) => {
        setShop(data.data);
        console.log("____ shopkeeper", data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getShopkeeperRents = async () => {
    setLoading(true);
    await Shopkeeper.getRents(shopkeeperId)
      .then((data) => {
        console.log("____ shopkeeper rents", data.data);
        setRents(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const getShopkeeperShops = async () => {
    setLoading(true);
    await Shopkeeper.getShops(shopkeeperId)
      .then((data) => {
        console.log("____ shopkeeper shops", data.data);
        setShopkeeperShops(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getShopkeeper();
    getShopkeeperRents();
    getShopkeeperShops();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      {shop && (
        <div class={user ? "page-wrapper" : "container"}>
          <Toast ref={toast} />
          <div class="content">
            <TitleHeader title="Shopkeeper Details" />

            <div class="row">
              <div class="col-lg-12 col-sm-12">
                <div class="card">
                  <div class="card-body">
                    <div class="productdetails">
                      <ul class="product-bar">
                        <li>
                          <h4>Branch</h4>
                          <h6>{shop.branchId} </h6>
                        </li>
                        <li>
                          <h4>Name</h4>
                          <h6>{shop.name} </h6>
                        </li>
                        <li>
                          <h4>Email</h4>
                          <h6>{shop.email}</h6>
                        </li>
                        <li>
                          <h4>Address</h4>
                          <h6>{shop.address}</h6>
                        </li>
                        <li>
                          <h4>Phone</h4>
                          <h6>{shop.phone}</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h2>Rents History</h2>
              <table className="table">
                <thead>
                  <th>Transaction</th>
                  <th>Date</th>
                  <th>Shop</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Exc Rate</th>
                </thead>
                <tbody>
                  {rents?.map((item) => (
                    <tr>
                      <td>{item.name}</td>
                      <td>{item.date}</td>
                      <td>{item.shopName}</td>
                      <td>{item.amount || "$0.00"}</td>
                      <td>{item.transactionType}</td>
                      <td>{item.currencyRate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <h2>Shops History</h2>
              <table className="table">
                <thead>
                  <th>Transaction</th>
                  <th>Date</th>
                  <th>Shop</th>
                  <th>Contract</th>
                  <th>Status</th>
                </thead>
                <tbody>
                  {shopkeeperShops?.map((item) => (
                    <tr>
                      <td>{item.name}</td>
                      <td>{item.contractDate}</td>
                      <td>{item.shopName}</td>
                      <td>{item.contractType}</td>
                      <td>{item.state}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ShopkeeperFullDetails;
